import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import Vue from 'vue';
import MasterStore from './MasterStore';
import store from '@/store';

import { getAsync, patchAsync } from '@/rpcutil';

export enum CompanyPlan {
    A = 0,
    B = 1,
    C = 2,
}

export enum CompanyUsingStatus {
    //TrialNotStarted = 1,
    TrialStarted = 1,
    PaidStarted = 0,
    Suspended = 2,
}

export enum CompanyPaymentStatus {
    Normal = 1,
    Delinquent = 2,
}

export enum CompanyPaymentMethod {
    CreditCard = 1,
    AccountTransfer = 2,
    Bill = 3,
}

export interface CompanyContractStatus {
    plan?: CompanyPlan;
    usage: CompanyUsingStatus;
};

export enum CompanyBankAccountType {
    Normal = 1,
    Current = 2,
}

export interface CompanyBankAccount {
    bankId: number,
    bankCode: string,
    bankName: string,
    branchCode: string,
    branchName: string,
    type: CompanyBankAccountType,
    num: string,
    name: string,
}

export interface CompanyCreditInfo {
    sendid: string,
    telno: string,
    email: string,
}

export interface CompanyStatus {
    sid: number;
    id: string,
    dbname: string,

    version: number,

    name: string,
    kana: string,

    contractStatus: CompanyContractStatus,

    startDate: Date,
}


type AgencyInfo = {
    agencyId: number,
    agencyBilling: number,
};

export interface CompanyDetail extends CompanyStatus {
    /* sid: number, */

    /* name: string, */
    /* kana: string, */

    /* id: string, */
    /* dbname: string, */

    zipcode: string,
    address: string,

    staffName: string,
    tel: string,
    email: string,

    /* startDate: Date, */
    /* contractStatus: CompanyContractStatus, */
    paymentStatus: CompanyPaymentStatus,
    paymentMethod: CompanyPaymentMethod,
    bankAccount?: CompanyBankAccount,
    creditInfo?: CompanyCreditInfo,

    branchNumber: number,
    branchMoney: number, // 実際に請求する料金

    rentalNumber: number,

    agencyInfo?: AgencyInfo,
}


let ctr = 0;

type CompanyDetailStore = {
    [sid: number]: CompanyDetail
};

function detailObjectize(detail: CompanyDetail) {
    const detailAny: any = detail;
    detail.startDate = new Date(detailAny.startDate);
}

function statusObjectize(status: CompanyStatus) {
    const statusAny: any = status;
    status.startDate = new Date(statusAny.startDate);
}


@Module({ name: 'company', namespaced: true, dynamic: true, store: store })
class CompanyStore extends VuexModule {
    details: CompanyDetailStore = {};
    status: CompanyStatus[] = [];

    @Mutation
    UPDATE_COMPANY_DETAIL(detail: CompanyDetail) {
        Vue.set(this.details, detail.sid, detail);
    }

    @Mutation
    UPDATE_COMPANY_STATUS_SOLE(status: Partial<CompanyStatus>) {
        const idx = this.status.findIndex(x => x.sid == status.sid);
        if(idx != -1)
            Vue.set(this.status, idx, { ...this.status[idx], ...status });
    }

    @Mutation
    UPDATE_COMPANY_STATUS(val: CompanyStatus[]) {
        for(let i = 0; i < val.length; i++) {
            Vue.set(this.status, i, val[i]);
        }
        const delete_count = this.status.length - val.length;
        for(let i = 0; i < delete_count; i++) {
            Vue.delete(this.status, val.length);
        }
    }

    @Mutation
    INVALIDATE_COMPANIES() {
        this.details = {};
    }

    @Action({ rawError: true })
    async updateStatus() {
        const statuses: CompanyStatus[] = (await getAsync('/api/company/status')).data;

        // convert some objects
        for(const status of statuses) {
            statusObjectize(status);
        }

        this.INVALIDATE_COMPANIES();
        this.UPDATE_COMPANY_STATUS(statuses);
    }

    @Action({ rawError: true })
    async updateDetail(sid: number) {
        if(typeof(sid) !== "number") sid = parseInt(sid);
        const detail: CompanyDetail = (await getAsync('/api/company/' + sid)).data;
        detailObjectize(detail);
        this.UPDATE_COMPANY_DETAIL(detail);
    }

    @Action({ rawError: true })
    async getStatusList(): Promise<CompanyStatus[]> {
        if(this.status.length == 0) {
            await this.updateStatus();
        }
        return this.status;
    }

    @Action({ rawError: true })
    async getDetail(sid: number): Promise<CompanyDetail> {
        if(!this.details[sid]) await this.updateDetail(sid);
        return this.details[sid];
    }

    @Action({ rawError: true })
    async modifyDetail({ id, mods }: { id: number, mods: Partial<CompanyDetail> }) {
        if(Object.keys(mods).length > 0) {
            // send
            const result = await patchAsync('/api/company/' + id, mods);
            if(result.data.result == "ok") {
                // apply locally
                if(this.details[id])
                    this.UPDATE_COMPANY_DETAIL(Object.assign(Object.assign({}, this.details[id]), mods));
                this.UPDATE_COMPANY_STATUS_SOLE({ sid: id, ...mods });
                return true;
            }
            else
                return false;
        }
    }
}

export default getModule(CompanyStore);
